module.exports = __webpack_public_path__ + "img/magic-internet-money.4868c67f.png";